import { render, staticRenderFns } from "./SpecificationArticle.vue?vue&type=template&id=35c1ecab&scoped=true"
import script from "./SpecificationArticle.vue?vue&type=script&lang=js"
export * from "./SpecificationArticle.vue?vue&type=script&lang=js"
import style0 from "./SpecificationArticle.vue?vue&type=style&index=0&id=35c1ecab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1ecab",
  null
  
)

export default component.exports